import http from '../../../assets/extra/_httpServices';
import { updateLoadingScreen } from '../../../redux/Actions';
import { urls } from '../../../components/common/constants';
import * as types from './ReportsActionType'
import axios from 'axios';

const updateUserLogReportData = (data) => {
    return {
        type: types.USER_LOG_REPORT_DATA,
        payload: data,
    }
}
const updatePrePondGnReportData = (data) => {
    return {
        type: types.PREPOND_POSTPOND_GNREPORT,
        payload: data,
    }
}
const updatePrePondACReportData = (data) => {
    return {
        type: types.PREPOND_POSTPOND_ACREPORT,
        payload: data,
    }
}
const updateBookingType = (data) => {
    return {
        type: types.UPDATE_BOOKING_TYPE,
        payload: data,
    }
}
const updateGenAiReportData = (data) => {
    return {
        type: types.UPDATE_GENAI_REPORT,
        payload: data,
    }
}


// export const getUserLogReportData = (params) => {
//     return (dispatch) => {
//         dispatch(updateLoadingScreen(true))
//         .HttpCall(urls.getUserWiseCollection, "post", {}, params)
//             .then((response) => {
//                 dispatch(updateLoadingScreen(false))
//                 // if (response.status === 200 && response.data.status) {
//                 //     dispatch(updateUserLogReportData(response.data.Data.Table));
//                 // } else {
//                 //     dispatch(updateUserLogReportData([]));
//                 // }
//             })
//             .catch((error) => {
//                 console.log("Error: ", error);
//                 dispatch(updateLoadingScreen(false))
//                 dispatch(updateUserLogReportData([]))
//             })
//     }
// }
// export const getUserLogReportData = (data) => (dispatch) => {
//     return new Promise((resolve, reject) => {
//         dispatch(updateLoadingScreen(true))
//         http
//             .HttpCall(urls.getUserWiseCollection, "post", data,{} )
//             .then((res) => {
//                 dispatch(updateLoadingScreen(false))
//                 return resolve(res)
//             })
//             .catch((error) => {
//                 dispatch(updateLoadingScreen(false))
//                 reject(error)
//             })
//     })
// }

export const getUserLogReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getUserWiseCollection, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getGstReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getGstReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBusStandTransSummeryReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBusStandTransSummeryReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getAdhocRefundDetailsReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getAdhocRefundDetailsReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPrePondPostGnReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPrePondPostGnReportData, data)
            .then((res) => {
                if (res.status === 200 && res.data.status) {
                    if (res.data?.Data?.Table?.length > 0) {
                        dispatch(updatePrePondGnReportData(res.data?.Data?.Table))
                    } else {
                        dispatch(updatePrePondGnReportData([]))
                    }
                } else {
                    //handle alert
                    dispatch(updatePrePondGnReportData([]))
                }
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getPrePondPostACReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPrePondPostACReportData, data)
            .then((res) => {
                if (res.status === 200 && res.data.status) {
                    if (res.data?.Data?.Table?.length > 0) {
                        dispatch(updatePrePondACReportData(res.data?.Data?.Table))
                    } else {
                        dispatch(updatePrePondACReportData([]))
                    }
                } else {
                    //handle alert
                    dispatch(updatePrePondACReportData([]))
                }
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getFranchiseeDepositRptData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeDepositReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getONBGWBSSReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getONBGWBSSReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getONBGWPTReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getONBGWPTReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getCocessionTicketReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCocessionTicketReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCancelledTicketReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCancelledTicketReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getPartialCancelledTicketReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.partialCancelledTicketReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getReservationChartReportTblData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getReservationChartReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBulkOnlineRefundTblData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getOnlineBulkRefundData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getCorporationWiseNoOfServiceData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCorporationWiseNoOfServices, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getDateWiseTrnGNReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDateWiseTrnGNReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getRegularServicesListData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRegularServicesList, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getDepotDivisionWiseData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDepotDivisionWiseData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getFullCancelledTicketReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.FullCancelledTicketReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCounterWiseReservationCollData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCounterWiseResCollData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getRevCollRepoCorpWise = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRevCollRepoCorpWise, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPGModeWiseEBookingTransactionData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.pGModeWiseEBookingTransaction, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPGEBookingTransactionData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPgEBkngTransactionData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDateWiseMonthlyTransactionData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDateWiseMonthlyTransactionRptData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getRevenueToBeGivenToOtherDivisionsData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRevenueGivenToOtherDivisionsTblData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getIncomeEarnServiceNotRenderdRptData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getIncomeEarnServiceNotRenderdRptData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getRevenueToBeReceiveFromOtherDivisionsData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRevenueReceiveFromOtherDivisionsTblData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCounterWiseRevenueSummaryData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCounterWiseRevSummaryTblData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBoardingPointwiseReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBoardingPointwiseReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getTopupSuccessFailureReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTopupSuccessFailureReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getGNTPRefundReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getGNTPRefundReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getReconciliationReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getReconciliationReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getTripCodeWiseRevReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTripCodeWiseRevReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getGSTCollectedCarriageServicesReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getGSTCollectedCarriageServicesReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getEbookingDetSummary = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getEbookingDetSummary, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getMonthalyDetSummary = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getMonthalyDetSummary, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getCancelTransactionSummary = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCancelTransactionSummary, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getSpecialServiceReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getSpecialServiceRtpData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getBookingType = (params) => {
    return (dispatch) => {
        http.HttpGet(urls?.getBookingType, params)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(updateBookingType(response.data.Data.Table));
                } else {
                    dispatch(updateBookingType([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateBookingType([]))
            })
    }
}

export const getModeWiseOnlineTransactionReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getModeWiseOnlineTransactionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getSummaryRevenueRealizedReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getSummaryRevenueRealizedReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getFranchiseeObcbSummaryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeObcbSummaryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getCancelledServiceReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCancelledServiceReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPassengerDetailReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPassengerDetailReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCorporationWiseSeatDetailReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCorporationWiseSeatDetailReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPassengerBookingSummary = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPassengerBookingSummary, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getUserLoginHistoryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getUserLoginHistoryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getFranchiseeIncentiveSummaryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeIncentiveSummaryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getFranchiseeCommissionSummaryReportV2 = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeCommissionSummaryReportV2, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getFranchiseeDepRecDivisionReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeDepRecDivisionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBusStandWiseBookedETktReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBusStandWiseBookedETktReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDepotWiseAdvanceBookingReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDepotWiseAdvanceBookingReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBookingReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.BookingReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getManifestReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.ManifestReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getPartialManifestReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.PartialManifestReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getReceiveReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.ReceiveReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getPartialReceiveReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.PartialReceiveReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getDeliveryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.DeliveryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getPartialDeliveryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.getPartialDeliveryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getRemittanceReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGet(urls.RemittanceReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};

export const getClasswiseSeatsReservedRevenueSharedReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getClasswiseSeatsReservedRevenueSharedReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getTripWiseBookedSeatSummaryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTripWiseBookedSeatSummaryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getOnlineUserListReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true)); // Dispatch action to show loading screen
        axios.get(
            ` https://ksrtc.in/api/resource/filteredUserDetails?`, { params: data }) // Making a GET request using Axios
            .then((res) => {
                dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
                resolve(res); // Resolve with response data
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false)); // Dispatch action to hide loading screen
                reject(error); // Reject with error
            });
    });
};
export const getConcessionTicketSummaryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getConcessionTicketSummaryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getServiceCancelTicketOtherReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getServiceCancelTicketOtherReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getBookedSeatDetailsReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBookedSeatDetailsReport, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getServiceCancelTicketGenReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getServiceCancelTicketGenReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDivisionServiceWiseRevSummReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDivisionServiceWiseRevSummReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getUnManifestedReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getUnManifestedReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDepoDivCorpWiseRevCollectionRptData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDepoDivCorpWiseRevCollectionRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBlockUnblocklogReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBlockUnblocklogReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBusstandwiseFranchiseeCommisionReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBusstandwiseFranchiseeCommisionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDcRemittanceReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDcRemittanceReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getUserRemittanceReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getUserRemittanceReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getRouteAnalysisReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRouteAnalysisReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getProductAnalysisReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getProductAnalysisReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getUserRemittanceUpdate = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            // .HttpGet(urls.getUserRemittanceUpdate, data)
            .HttpCall(urls.getUserRemittanceUpdate, "post", {}, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getInsurenceCollectedReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getInsurenceCollectedReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getDemurragesAmountCollectionReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDemurragesAmountCollectionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDailyParcelRevenueCollectionReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDailyParcelRevenueCollectionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getGSTRReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getGSTRReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getManifestDashboardReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getManifestDashboardReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getReceiveDashboardReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getReceiveDashboardReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getReceiveDashboardHyperlinkReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getReceiveDashboardHyperlinkReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getDeliveryDashboardReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDeliveryDashboardReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getDeliveryDashboardHyperlinkReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDeliveryDashboardHyperlinkReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDailyRemittanceReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDailytRemittanceReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBookingSummaryReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBookingSummaryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getEarningReportHeadwise = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getEarningReportHeadwise, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBusinessFecilitatorReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBusinessFecilitatorReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDayWiseCommPayableReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDayWiseCommPayableReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCommissionListReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getComissionListReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDepotwiseManifestedCommissionReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDepotwiseManifestedCommissionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getMisRouteListReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getMisRouteListReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getRevenueReceivableReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRevenueReceivableReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPayableRevenueSharingReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPayableRevenueSharingReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getReceivableRevenueSharingReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getReceivableRevenueSharingReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getRevenuePayableReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRevenuePayableReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBoardingPointwiseDetail = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBoardingPointwiseDetail, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBoardingPointTripcodewiseDetail = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBoardingPointTripcodewiseDetail, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getUserLogSummaryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getUserLogSummaryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getTravelinfoReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTravelinfoReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getUnusedStockReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getUnusedStockReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getTripSheetSummaryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTripSheetSummaryReport, data)
            .then((res) => {
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getStatementOfAccountsForSaleOfTickets = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getStatementOfAccountsForSaleOfTickets, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBusStationWiseServicesAndFranchiseeReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBusStationWiseServicesAndFranchiseeReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBookingSummaryForGivenPeriodReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBookingSummaryForGivenPeriodReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getPNRWiseBookingCancelRpt = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPNRWiseBookingCancelRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getFeedbackRatingReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFeedbackRatingReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getPNRWiseTransRpt = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPNRWiseTransRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getAdhocDetailRpt = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getAdhocDetailRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getTransStatusList = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTransStatusList, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCancellationSummary = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCancellationSummaryData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getOnlineCustGstRpt = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getOnlineCustGstRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDailyRevenueForTheMonth = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDailyRevenueForTheMonth, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getServiceWiseSeatAvailabilityReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getServiceWiseSeatAvailabilityReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getStationWiseServiceTypeData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getStationWiseServiceType, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getDailyStockConsumptionReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDailyStockConsumptionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const FranchiseeCommissionSummaryReport_DailyData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeCommissionSummaryReport_Daily, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getVacancySeatReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getVacancySeatReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getAdvanceBookedSeatsRevenueReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getAdvanceBookedSeatsRevenueReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getDivisionwiseMonthlyCollection = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDivisionwiseMonthlyCollection, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getSpecialIncentivesMasterReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getSpecialIncentivesMasterTable, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getTicketBlockConsumptionReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getTicketBlockConsumptionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getBookedSeatsSummaryDepotWiseReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBookedSeatsSummaryDepotWiseReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getBookedSeatDepotWiseReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBookedSeatDepotWiseReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getBlockTicketReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBlockTicketReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getCancelTktAdvanceBookStopReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCancelTktAdvanceBookStopReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getFranchiseeCommissionDiffReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeCommissionDiffReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getGST_TDSDeductRptData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getGST_TDSDeductRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getStockSkipDetailsReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getStockSkipDetailsReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getLevySlabwiseCollectionSeatsBookedSummary = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getLevySlabwiseCollectionSeatsBookedSummary, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getRevenueThroughAWATAR = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRevenueThroughAWATAR, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getHeighestBookingFromCityToCityReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getHeighestBookingFromCityToCityReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getForeignDomesticTravelInfoReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getForeignDomesticTravelInfoReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getAgentBalanceSummaryData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getAgentBalanceSummary, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getRevenueRealizedThroughAcPassengerStageCarrierServices = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getRevenueRealizedThroughAcPassengerStageCarrierServices, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getFranchiseeTopupRptData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeTopupRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getBusStandWiseFranchiseeCommGSTTDSRpt = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getBusStandWiseFranchiseeCommGSTTDSRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const FranchiseeCommissionSummaryReport_MonthlyData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFranchiseeCommissionSummaryReport_Monthly, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getDivisionWiseRevRetainedReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDivisionWiseRevRetainedReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getServiceCancAfterJourneyDateReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getServiceCancAfterJourneyDateReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}


export const getServiceCancelRpt = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getServiceCancelRpt, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getServiceTypeTransactionSummary = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getServiceTypeTransactionSummary, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getDateWiseRevenueReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getDateWiseRevenueReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getCounterWiseBookingComparisonReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCounterWiseBookingComparisonReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getFareMasterSummaryReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getFareMasterSummaryReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getCrewAppLoginLogReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getCrewAppLoginLogReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPGTransactionStatusReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPGTransactionStatusReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const getAvlTripDates = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getAvlTripDates, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPOSTransactionReport = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPOSTransactionReport, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}

export const getPOSBankGatewayReportData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getPOSBankGatewayReportData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
export const GetPDGenAIReport = (params, isCache = false, cacheDuration = 0) => {
    return (dispatch) => {
        http.GetRequestCached(urls?.GetPDGenAIReport, params, isCache, cacheDuration)
            .then((response) => {
                if (response.status === 200 && response.data.status) {
                    dispatch(updateGenAiReportData(response.data.Data.Table));
                } else {
                    dispatch(updateGenAiReportData([]));
                }
            })
            .catch((error) => {
                console.log("Error: ", error);
                dispatch(updateGenAiReportData([]))
            })
    }
}
export const getBookingReportOldData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGetV3(urls.BookingReportOldData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getManifestReportOldData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGetV3(urls.ManifestReportOldData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getDeliveryReportOldData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGetV3(urls.DeliveryReportOldData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getReceiveReportOldData = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true));
        http.HttpGetV3(urls.ReceiveReportOldData, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false));
                return resolve(res);
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false));
                reject(error);
            });
    });
};
export const getONBGWBSSReportDataWapp = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(updateLoadingScreen(true))
        http
            .HttpGet(urls.getONBGWBSSReportDataWapp, data)
            .then((res) => {
                dispatch(updateLoadingScreen(false))
                return resolve(res)
            })
            .catch((error) => {
                dispatch(updateLoadingScreen(false))
                reject(error)
            })
    })
}
